import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
const { GUEST_CONNECTIONS_COMPONENT_ID, VIEWER_OBJECT_COMPONENT_ID } = ComponentIds;
export const getEntityPosition = (dragStateComponent) => {
    var _a;
    const draggedEntity = dragStateComponent.dragState.originalDraggedEntity;
    const currentPos = (_a = draggedEntity.getComponent(GUEST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections[0].hostConnector.key;
    if (!currentPos)
        throw new Error("Unable to establish dragged entity's position");
    return currentPos;
};
const wasEntityMoved = (dragStateComponent, oldPosition) => oldPosition !== getEntityPosition(dragStateComponent);
/**
 * Gets the invisible box entity
 * rootEntity is the scene, since that's the entity the DragStateComponent ends up on.
 */
const getBoxEntity = (rootEntity, position) => HierarchyUtils.hierarchy(rootEntity).find((entity) => {
    var _a;
    return (_a = entity
        .getComponent(GUEST_CONNECTIONS_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.connections[0].hostConnector.key.includes(position);
});
const toggleInputEvent = (entity, type) => {
    var _a;
    const entityViewerObject = (_a = entity === null || entity === void 0 ? void 0 : entity.getComponent(VIEWER_OBJECT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.viewerObject;
    switch (type) {
        case "register":
            entityViewerObject === null || entityViewerObject === void 0 ? void 0 : entityViewerObject.registerInputEvents();
            break;
        case "unregister":
            entityViewerObject === null || entityViewerObject === void 0 ? void 0 : entityViewerObject.unregisterInputEvents();
            break;
    }
};
export const toggleInvisibleBoxInputEvent = (entity, dragStateComponent, oldPosition) => {
    const newPosition = getEntityPosition(dragStateComponent);
    if (oldPosition && wasEntityMoved(dragStateComponent, oldPosition)) {
        const oldBox = getBoxEntity(entity, oldPosition);
        const newBox = getBoxEntity(entity, newPosition);
        toggleInputEvent(oldBox, "register");
        toggleInputEvent(newBox, "unregister");
    }
};
/**
 * Determine whether to run the callback to update the state of the application that an insert was moved
 */
export const runCallback = (callback, dragStateComponent, oldPosition) => wasEntityMoved(dragStateComponent, oldPosition) && callback && callback();
